import {useMatchMedia} from '@pexip/hooks';

import {MOBILE_DEVICE} from '../../constants/mediaQueries';

export const useMobileDevice = () => useMatchMedia(MOBILE_DEVICE);
